const isInternalLink = link => !(new RegExp(/^[a-zA-Z]+:(?!(\/\/(www\.)?muzey-pimonenko.org))/)).test(link);

export default isInternalLink;
